import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inboxId", "label", "use"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { getGates } from 'conversations-thread-data/auth/public/selectors';
import { useChannelInstancesForChannel } from 'conversations-thread-data/channel-instances/public/hooks';
import { useConnectedAccounts } from 'conversations-thread-data/connected-accounts/public';
// @ts-expect-error module not typed
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import { useSelector } from 'react-redux';
import { useFloatingEditorState } from '../hooks/useFloatingEditorState';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
function useComponent({
  inboxId
}) {
  const {
    open: handleOpenFloatingEditor
  } = useFloatingEditorState();
  const gates = useSelector(getGates);
  const isUngatedForWhatsAppCompose = gates.includes('Communication:Inbox:WhatsAppCompose');
  const {
    asyncConnectedAccounts
  } = useConnectedAccounts({
    inboxId,
    filterNonGlobalAccounts: true
  });
  const {
    channelInstances
  } = useChannelInstancesForChannel({
    inboxId,
    channelId: WHATSAPP_GENERIC_CHANNEL_ID,
    deferred: !isUngatedForWhatsAppCompose
  });
  const connectedAccounts = getData(asyncConnectedAccounts);
  const isEmailConnected = connectedAccounts === null || connectedAccounts === void 0 ? void 0 : connectedAccounts.size;
  const isWhatsAppConnected = channelInstances === null || channelInstances === void 0 ? void 0 : channelInstances.size;
  const isVisible = isEmailConnected || isUngatedForWhatsAppCompose && isWhatsAppConnected;
  return {
    handleOpenFloatingEditor,
    isVisible
  };
}
const _ComposeMessageButton = _ref => {
  let {
      inboxId,
      label,
      use = 'tertiary'
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    handleOpenFloatingEditor,
    isVisible
  } = useComponent({
    inboxId
  });
  return isVisible ? /*#__PURE__*/_jsx(Button, Object.assign({
    "data-test-id": "compose-email-button",
    onClick: handleOpenFloatingEditor,
    size: "small",
    use: use
  }, buttonProps, {
    children: label || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.compose.compose-email-button.label"
    })
  })) : null;
};
_ComposeMessageButton.displayName = 'ComposeMessageButton';
export const ComposeMessageButton = provideThreadView(_ComposeMessageButton);
ComposeMessageButton._Internal = _ComposeMessageButton;